import React from 'react'

/**
 * Tema comum dos gráficos de linha do dashboard.
 *
 * O nivo vinha com os padrões dele (texto #333 em sans-serif genérica, eixos
 * pretos), que destoavam do resto da identidade. Aqui os eixos passam a usar a
 * mesma escala de cinzas dos rótulos do menu e dos cartões: traço #eef1f5,
 * rótulo #98a2b3, grade #f2f4f7.
 */
export const dashboardChartTheme = {
  fontFamily: "'Open Sans', sans-serif",
  fontSize: 10.5,
  textColor: '#98a2b3',
  axis: {
    domain: {
      line: {
        stroke: '#eef1f5',
        strokeWidth: 1
      }
    },
    ticks: {
      line: {
        stroke: '#eef1f5',
        strokeWidth: 1
      },
      text: {
        fill: '#98a2b3',
        fontSize: 10.5
      }
    }
  },
  grid: {
    line: {
      stroke: '#f2f4f7',
      strokeWidth: 1
    }
  },
  crosshair: {
    line: {
      stroke: '#98a2b3',
      strokeWidth: 1,
      strokeOpacity: 0.7,
      strokeDasharray: '4 4'
    }
  }
}

/**
 * Um mês de dados não cabe no eixo: 30 rótulos viram um borrão
 * ("0708/0809/0910/..."). Em vez de girar o texto, mostramos um a cada N e
 * garantimos que o primeiro e o último apareçam, que são os que dão o recorte
 * do período.
 */
export function thinTicks(data: any[], max = 8): string[] | undefined {
  const longest = data.reduce(
    (acc: any[], serie: any) =>
      serie?.data?.length > acc.length ? serie.data : acc,
    [] as any[]
  )

  const total = longest.length

  if (total <= max) {
    return undefined
  }

  /* Índices distribuídos por igual entre o primeiro e o último ponto. Um
     `index % passo` simples deixaria o último rótulo colado no penúltimo
     ("05/1006/10" era o que aparecia no widget de cadastros). */
  const ticks: string[] = []

  for (let i = 0; i < max; i += 1) {
    const index = Math.round((i * (total - 1)) / (max - 1))
    const value = String(longest[index].x)

    if (!ticks.includes(value)) {
      ticks.push(value)
    }
  }

  return ticks
}

/**
 * Balão branco com a faixa da cor da série à esquerda, no lugar do retângulo
 * cinza-escuro antigo. Mesma sombra dos cartões flutuantes da identidade nova
 * (flyout do menu, painel de notificações).
 */
export const ChartTooltip: React.FC<{ color: string }> = ({
  color,
  children
}) => (
  <div
    style={{
      padding: '8px 11px',
      borderRadius: '8px',
      borderLeft: `3px solid ${color}`,
      background: '#fff',
      boxShadow: '0 8px 22px rgba(16, 24, 40, 0.14)',
      fontSize: '12px',
      lineHeight: 1.45,
      color: '#344054',
      whiteSpace: 'nowrap'
    }}
  >
    {children}
  </div>
)
